export const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
export const ENCRYPTION_KEY =
  process.env.REACT_APP_TOKEN_EXCHANGE_ENCRYPTION_KEY || "";
